import { z } from 'zod';
import { StepFunctionTaskContextSchema } from '../request.js';
import { GatherTemplateTokensInputSchema } from './gatherTemplateTokens.js';
import { RetrieveTokenValuesOutputSchema } from './retrieveTokenValues.js';
export const CreateDraftDocumentInputSchema = GatherTemplateTokensInputSchema.merge(RetrieveTokenValuesOutputSchema);
export const CreateDraftDocumentOutputSchema = GatherTemplateTokensInputSchema;
export const CreateDraftDocumentRequestSchema = z.object({
    context: StepFunctionTaskContextSchema,
    input: CreateDraftDocumentInputSchema,
});
